import React, { useEffect, useState } from 'react';

import TokenPreview from './TokenPreview';
import Search from './Search';


export default function TokenList() {
    const [tokenList, setTokenList] = useState(null);
    const [searchTokenList, setSearchTokenList] = useState(null);
    const [search, setSearch] = useState('');
    const [protocol, setProtocol] = useState('plot')

    const sanityzePlotMetadata = (metadata) => {
        let fields = metadata.substring(1, metadata.length - 1).split(',');
        fields[4] = fields[4] + ',' + fields[5] + ',' + fields[6];
        fields = fields.slice(0, 5).concat(fields.slice(-2));
        let meta = [];
        fields.map((field) => meta[field.split(': ')[0]] = field.split(': ')[1]);
        return(meta);
    }

    const sanityzeCo2Metadata = (metadata) => {
        let fields = metadata.substring(1, metadata.length - 1).split(',');
        let plots = '';
        fields.slice(2, fields.length - 3).map((field) => {
            return plots += field + ',';
        })
        fields[2] = plots.substring(0, plots.length - 1);
        fields = fields.slice(0, 3).concat(fields.slice(-3));
        let meta = [];
        fields.map((field) => meta[field.split(': ')[0]] = field.split(': ')[1]);
        return(meta);
    }

    useEffect(() => {
        if (tokenList === null) {
            fetch('https://nftree.herokuapp.com/api/nft/list?protocol=' + protocol)
            .then((res) => res.json()
                .then((data) => setTokenList(data.message)))
            .catch((err) => console.log(err));
        }
    }, [protocol, tokenList]);

    useEffect(() => {
        if (search) {
            let searchTokens = [];
            if (tokenList) {
                if (protocol === 'plot') {
                    tokenList.forEach((token, key) => {
                        if (token.metadata.split(',')[0].search(search) !== -1)
                            searchTokens.push(token);
                    });
                }
                else {
                    tokenList.forEach((token, key) => {
                        let metadata = token.metadata.split(',').reverse()
                        if (metadata[2].search(search) !== -1)
                            searchTokens.push(token);
                    });
                }

                if (searchTokens.length > 0)
                    setSearchTokenList(searchTokens);
                else
                    setSearchTokenList([]);
            }
        } 
        else {
            setSearchTokenList(null);
        }
    }, [search, tokenList, protocol])

    const handleSearch = (value) => {
        setSearch(value);
    };

    const handleProtocol = (value) => {
        setProtocol(value);
        setTokenList(null);
    };

    return(
	<>
        <header className="bg-white shadow">
            <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold leading-tight text-gray-900">
                Token List
                </h1>
            </div>
        </header>
        <main>
            <Search handleSearch={ handleSearch } search={ search } handleProtocol={ handleProtocol } protocol={ protocol } />
            <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 py-6 sm:px-0">
                    { searchTokenList ? searchTokenList.length > 0 ?
                        searchTokenList.map((token, index) => {
                            return <TokenPreview key={ index } nftid={ token.nftId } protocol={ protocol } nftOwnerKeyId={ token.nftOwnerKeyId } metadata={ protocol === 'plot' ?sanityzePlotMetadata(token.metadata) : sanityzeCo2Metadata(token.metadata) } /> 
                        }) : "No matches" 
                        : tokenList ? tokenList.map((token, index) => {
                            return <TokenPreview key={ index } nftid={ token.nftId } protocol={ protocol } 
                            nftOwnerKeyId={ token.nftOwnerKeyId } metadata={ protocol === 'plot' ?sanityzePlotMetadata(token.metadata) : sanityzeCo2Metadata(token.metadata) } />
                        }) : "Loading"
                    }
                </div>
            </div>
        </main>
	</>
    );
}

